import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import AIAssistantDirect from 'app/pages/AiAssistant/exposes/AIAssistant';
import { useAiAssistantSlice } from 'app/pages/AiAssistant/store';
import { useRoadmapAiAssistantContext } from 'app/hooks/useRoadmapAiAssistantContext';
import { setUserEmailGetter } from 'app/pages/AiAssistant/services/authBridge';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';

import styles from './AiAssistantSection.module.scss';

/** Embedded AI assistant for the slideout main content column (not a viewport overlay). */
export function AiAssistantSection() {
  useAiAssistantSlice();
  const userProfile = useSelector(selectUserProfile);
  const context = useRoadmapAiAssistantContext();

  useEffect(() => {
    const email = userProfile?.email || userProfile?.mail || null;
    setUserEmailGetter(() => email);
  }, [userProfile]);

  return (
    <div className={styles.root} data-testid="slideout-ai-assistant-section">
      <AIAssistantDirect isOpen context={context} />
    </div>
  );
}
